"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeManager = void 0;
var MathUtils = require("../Utils/MathUtils");
var ResizeManager = /** @class */ (function () {
    function ResizeManager(pSizeMin, pSizeMax) {
        this._sizeMin = pSizeMin;
        this._sizeMax = pSizeMax;
        this.updateRatio();
    }
    Object.defineProperty(ResizeManager.prototype, "sizeMin", {
        set: function (pSize) {
            this._sizeMin.copyFrom(pSize);
            this.updateRatio();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResizeManager.prototype, "sizeMax", {
        set: function (pSize) {
            this._sizeMax.copyFrom(pSize);
            this.updateRatio();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResizeManager.prototype, "windowAspectRatio", {
        get: function () {
            return window.innerWidth / window.innerHeight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResizeManager.prototype, "gameAspectRatio", {
        get: function () {
            return MathUtils.clamp(this.windowAspectRatio, this._ratioMin, this._ratioMax);
        },
        enumerable: false,
        configurable: true
    });
    ResizeManager.prototype.getSize = function () {
        var size = new PIXI.Point();
        // TODO:SH: Y scaling is currently not supported. Look into a more flexible solution
        size.y = this._sizeMax.y;
        size.x = size.y * this.gameAspectRatio;
        return size;
    };
    ResizeManager.prototype.getStageScale = function () {
        // if the window is wider than we support, fill the entire height
        if (this.gameAspectRatio < this.windowAspectRatio) {
            return window.innerHeight / this.getSize().y;
        }
        // otherwise, window is narrower or equal to what we support, so we fill the entire width
        else {
            return window.innerWidth / this.getSize().x;
        }
    };
    ResizeManager.prototype.updateRatio = function () {
        this._ratioMin = this._sizeMin.x / this._sizeMin.y;
        this._ratioMax = this._sizeMax.x / this._sizeMax.y;
    };
    return ResizeManager;
}());
exports.ResizeManager = ResizeManager;
//# sourceMappingURL=ResizeManager.js.map